module.exports = __webpack_public_path__ + "img/step_1_bg.55ecfd84.png";